var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83329 11.5L11.744 9.58927C12.0695 9.26384 12.0695 8.7362 11.744 8.41076L9.83329 6.50002M11.5 9.00002L5.66662 9.00002M8.99996 17.3334C13.6023 17.3334 17.3333 13.6024 17.3333 9.00002C17.3333 4.39765 13.6023 0.666688 8.99996 0.666688C4.39759 0.666688 0.666625 4.39765 0.666625 9.00002C0.666625 13.6024 4.39759 17.3334 8.99996 17.3334Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextBtn);
export default __webpack_public_path__ + "static/media/next-btn.785a4668fe43e96ed31a6e4fb4ab41d0.svg";
export { ForwardRef as ReactComponent };